import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  ...theme.layouts.stepGrid,
  gridMainContainer: {
    padding: '.5rem 1rem 1rem 1rem',
    margin: 'auto',
    maxWidth: '1280px',
  },
  detailsCorrectHeading: {
    maxWidth: '35rem',
  },
  actionButton: {
    paddingBottom: '3rem',
    marginTop: '3rem',
    '& button': {
      minWidth: '13rem',
      '@media (min-width: 321px)': {
        minWidth: '18rem',
      },
    },
    '@media (max-width: 767px)': {
      flexDirection: 'column',
      display: 'flex',
      justifyContent: 'center',
      '& button': {
        margin: '1rem 0',
      },
    },
  },
}));
